export enum Phase {
    I = 'I', II = 'II', III = 'III'
}
